import { Link } from "react-router-dom";
import { Empty } from "~/components/base/Empty";
import { Button } from "~/components/base/Button";
import { useT } from "~/hooks/useT";

export default function NotFound() {
  const { t } = useT();
  return (
    <div data-screen-label="not-found" className="page">
      <Empty
        title={t("not_found_title")}
        subtitle={t("not_found_subtitle")}
        cta={
          <Link to="/dashboard">
            <Button variant="blue">{t("go_to_dashboard")}</Button>
          </Link>
        }
      />
    </div>
  );
}
